(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hw-related-collections"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hw-related-collections')) {
    class HwRelatedCollections extends HTMLElement {
      connectedCallback() {
        this.scroller = this.querySelector('.hw__related_collections__scroller');
        this.items = this.scroller ? this.scroller.querySelectorAll('.hw__related_collections__item') : [];

        if (this.items.length < 2 || !('IntersectionObserver' in window)) return;

        this.first = this.items[0];
        this.last = this.items[this.items.length - 1];
        this.flip = getComputedStyle(this.scroller).direction === 'rtl' ? -1 : 1;
        this.prevButton = this.querySelector('[data-hw-direction="prev"]');
        this.nextButton = this.querySelector('[data-hw-direction="next"]');

        /* Edge items count as in view once almost fully visible, allowing for subpixel rounding */
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            const inView = entry.isIntersecting && entry.intersectionRatio >= 0.9;
            this.setMore(entry.target === this.first ? 'start' : 'end', !inView);
          });
        }, { root: this.scroller, threshold: [0, 0.9, 1] });

        this.observer.observe(this.first);
        this.observer.observe(this.last);

        this.onClick = (event) => {
          const button = event.target.closest('[data-hw-direction]');
          if (button) this.scrollByStep(button.dataset.hwDirection === 'next' ? 1 : -1);
        };
        this.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.onClick) this.removeEventListener('click', this.onClick);
      }

      setMore(edge, more) {
        this.toggleAttribute(`data-hw-more-${edge}`, more);
        const button = edge === 'start' ? this.prevButton : this.nextButton;
        if (button) button.disabled = !more;
      }

      /* Scrolls by one item, or by the whole items in view so the peeking item becomes the first */
      scrollByStep(direction) {
        const step = Math.abs(this.items[1].offsetLeft - this.first.offsetLeft);
        if (!step) return;

        const count = this.dataset.hwStep === 'page' ? Math.max(1, Math.floor(this.scroller.clientWidth / step)) : 1;
        this.scroller.scrollBy({ left: direction * count * step * this.flip });
      }
    }

    customElements.define('hw-related-collections', HwRelatedCollections);
  }

  } catch(e) { console.error(e); }
})();
})();
